import { render, staticRenderFns } from "./vehicle_motor_torque_data.vue?vue&type=template&id=16b5d29e&scoped=true"
import script from "./vehicle_motor_torque_data.vue?vue&type=script&lang=js"
export * from "./vehicle_motor_torque_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b5d29e",
  null
  
)

export default component.exports